import { cn } from "@/utils";

export default function StatCard({ label, value, icon: Icon, color = "teal", trend }) {
  const colorMap = {
    teal:   { bg: "bg-[hsl(var(--zt-teal))]/8",  icon: "text-[hsl(var(--zt-teal))]",  border: "border-[hsl(var(--zt-teal))]/15" },
    gold:   { bg: "bg-[hsl(var(--zt-gold))]/10", icon: "text-[hsl(var(--zt-gold))]",  border: "border-[hsl(var(--zt-gold))]/20" },
    green:  { bg: "bg-emerald-50",               icon: "text-emerald-600",             border: "border-emerald-100" },
    orange: { bg: "bg-orange-50",                icon: "text-orange-500",              border: "border-orange-100" },
    red:    { bg: "bg-red-50",                   icon: "text-red-500",                 border: "border-red-100" },
  };
  const c = colorMap[color] || colorMap.teal;

  return (
    <div className="bg-white rounded-2xl border border-[hsl(var(--zt-beige-deep))] p-6 flex items-start gap-4 shadow-sm hover:shadow-md transition-shadow">
      <div className={cn("w-11 h-11 rounded-xl grid place-items-center flex-shrink-0 border", c.bg, c.border)}>
        <Icon size={20} className={c.icon} />
      </div>
      <div className="min-w-0">
        <p className="font-heading uppercase tracking-[0.18em] text-[10px] text-[hsl(var(--zt-charcoal))]/55 font-bold mb-1">{label}</p>
        <p className="font-display text-3xl text-[hsl(var(--zt-teal))] font-bold leading-none">{value ?? "—"}</p>
        {trend && <p className="text-[11px] text-[hsl(var(--zt-charcoal))]/50 mt-1 font-body">{trend}</p>}
      </div>
    </div>
  );
}
